import { useState } from 'react';
import { WellsFargoSettingsApi } from '@/api/clients/wells-fargo-settings/wells-fargo-settings.api';

export const useSaveWellsFargoApiCredential = () => {
  const [loading, setLoading] = useState(false);

  const saveCredential = async (organizationId, data) => {
    setLoading(true);
    try {
      return await WellsFargoSettingsApi.saveApiCredential(
        organizationId,
        data,
      );
    } finally {
      setLoading(false);
    }
  };

  return { saveCredential, loading };
};
